import React, { useState, useEffect } from 'react';
import { Text, View, ScrollView } from 'react-native';

import { store } from '../../store/store';
import { doPost as omsDoPost } from '../../utils/services/api/OMSAPI';
import { mapImageUrlToList } from '../../utils/services/oms/OMSCartUtils';
import { cap1stChar, getStringWithItemCount } from '../../utils/services/CommonUtils';
import { loaderModal as AlertLoaderModal } from '../../utils/services/AlertLoaderService';
import { getFileDownloadUrlList, getUnitPrice, refreshOrder } from '../../utils/services/oms/OMSUtils';
import { CacheDataToRefresh, DeeplinkDataSubscription, orderListSubscriptionForOrderSummary } from '../../utils/services/subject-behaviour/CommonRxjsService';

import { IconView } from '../../utils/widgets/CommonWidget/Icons';
import { HorizontalDivider } from '../../utils/widgets/Common-Widget';
import { LocationIconView } from '../../utils/widgets/Location/Location-Widget';
import { OrderSummaryHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { IndiaRupee } from '../../utils/constants/AppConstants';
import { OrderStatus } from '../../utils/constants/oms/OrderStatus';
import { reformatLocationString } from '../../utils/services/ReformatUtils';
import { CancelReason } from '../../utils/constants/BottomSheetSurveyContent';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import AppStyles from '../../AppStyles';

import RateOrderModal from '../../utils/modals/RateOrderModal';
import OrderImageListView from '../../utils/widgets/chemistOrder/OrderImageList';
import MultipleOptionSelectionBottomSheet from '../../utils/modals/MultipleSelectionBottomSheet';

import RefreshCacheConstant from '../../utils/services/webapp-services/RefreshCache';

import * as MoengageUtils from '../../utils/services/webapp-services/MoengageUtils';

const OrderSummaryView = (props) => {

    const [orderDetails, updateOrderDetails] = useState(props.route.params?.orderData ?? null)
    const [imageList, updateImagesList] = useState([])

    const [rateOrderModal, setRateOrderModal] = useState(false);
    const [cancleOrderModal, setCancelOrderModal] = useState(false);

    function getHeaderString() {
        return 'Order #' + orderDetails['oid']
    }

    function showCancleOrderBtn(orderDetails) {
        return orderDetails['orderStatus'] == OrderStatus.inProgress ||
            orderDetails['orderStatus'] == OrderStatus.received
    }

    function showRateOrderBtn(orderDetails) {
        return !orderDetails['isActiveOrder'] &&
            !orderDetails['isCancelOrder'] && !orderDetails['feedback']
    }

    async function getOrderImageList(orderDetails) {
        let orderImageList = await getFileDownloadUrlList(
            orderDetails?.prescription?.markedImages ??
            orderDetails?.prescription?.orgImages);
        if (orderImageList && orderImageList.length) {
            let orderImageUrlList = mapImageUrlToList(orderImageList)
            updateImagesList(orderImageUrlList)
        }
    }


    const orderSubscriptions = () => {
        orderListSubscriptionForOrderSummary.getOrderList().subscribe((updatedOrderList: any) => {
            if (updatedOrderList && updatedOrderList.length > 0) {
                let _orderData = updatedOrderList.find((item) =>
                    item.oid === props.route.params?.orderId)
                if (_orderData) {
                    updateOrderDetails(_orderData);
                    if (_orderData.hasOwnProperty('prescription'))
                        getOrderImageList(_orderData)
                }
            }
        })
    }

    const showRateOrderModal = () => {
        setRateOrderModal(true)
    }

    const closeRateOrderModal = () => {
        setRateOrderModal(false)
    }

    const showCancelOrderModal = () => {
        setCancelOrderModal(true)
    }

    const closeCancelOrderModal = () => {
        setCancelOrderModal(false)
    }

    function updateRatedOrder(ratedOrder) {
        refreshOrder()
        props.navigation.pop()
        props.navigation.navigate(ScreenRoute.orders)
    }

    function cancelOrder(selectedOptions, otherCancelDescp) {
        AlertLoaderModal.setLoader(true);
        let params = {
            orderId: orderDetails['oid'],
            cancellationReasonV2: {
                reasonIdentList: selectedOptions,
                otherReasonDesc: otherCancelDescp
            }
        }
        omsDoPost('order/cancel', params).then(
            (response: any) => {
                let refreshList = [{
                    name: RefreshCacheConstant.refreshOrderAndEconsultData,
                    requestData: { fetchOrders: true }
                }]
                CacheDataToRefresh.setRefreshList(refreshList)
                MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.oms_order_cancelled)
                if (props.navigation.canGoBack())
                    props.navigation.popToTop();
                props.navigation.replace(ScreenRoute.orders)
                AlertLoaderModal.setLoader(false);
            }, (err: any) => { console.log("API is failed with error " + err) }
        )
    }

    useEffect(() => {
        const reduxState = store.getState()
        if (reduxState.isUserLogin) {
            if (orderDetails) {
                if (orderDetails.hasOwnProperty('prescription'))
                    getOrderImageList(orderDetails)
            } else {
                // Require if coming from deeplink.
                CacheDataToRefresh.setRefreshList([{
                    name: RefreshCacheConstant.refreshOrderAndEconsultData,
                    requestData: { fetchOrders: true }
                }])
                orderSubscriptions()
            }
        } else {
            DeeplinkDataSubscription.setDeeplinkData({ deeplinkData: props.route.params })
            global.navigateFrom = NavigateFrom.deeplink_order_summary;
            props.navigation.replace(ScreenRoute.login);
        }
    }, [])

    const getItemsCount = (orderdetails) => {
        let count = 0;
        if (orderdetails['medications'])
            count += orderdetails['medications']?.length;
        if (orderdetails['products'])
            count += orderdetails['products'].length;
        return count;
    }

    return (
        <View style={{ backgroundColor: AppTheme.color.background, minHeight: '100vh' }}>
            {orderDetails ? <View>

                <OrderSummaryHeader navigation={props.navigation} title={getHeaderString()}
                    cancelOrder={showCancelOrderModal} showRateOrderModal={showRateOrderModal}
                    showCancelBtn={showCancleOrderBtn(orderDetails)}
                    showRateBtn={showRateOrderBtn(orderDetails)} />

                <ScrollView style={{ backgroundColor: AppTheme.color.background, marginTop: AppTheme.headerHeight }}>

                    <View>

                        {((orderDetails.medications && orderDetails?.medications?.length > 0) ||
                            (orderDetails?.products && orderDetails?.products?.length != 0)) ?

                            <View style={[AppStyles.mx16, AppStyles.mt24]}>

                                <Text style={[TextStyle.text16xb, { marginBottom: 10 }]}>
                                    Items({getItemsCount(orderDetails)})</Text>

                                {(orderDetails.medications && orderDetails?.medications?.length > 0) ? <View>

                                    {orderDetails['medications']?.map((medicine, index) => (

                                        <View style={[AppStyles.mediumShadow, AppStyles.flexRowSpaceBetween, {
                                            borderRadius: 12, paddingHorizontal: 16, paddingVertical: 16,
                                            marginVertical: 6, width: AppTheme.appWidth - 32, backgroundColor: 'white'
                                        }]}
                                            key={medicine['mmid']}>

                                            <View style={[{ alignContent: 'flex-start', width: (AppTheme.appWidth - 64) * 0.7 }]}>

                                                <Text numberOfLines={2} ellipsizeMode="head"
                                                    style={[TextStyle.text16, { flexWrap: "wrap" }]}>{medicine['name']}</Text>
                                                {
                                                    medicine['mmid'] ? <View>
                                                        <Text style={[TextStyle.text14xb, { color: AppTheme.color.green.primary, marginTop: 8, flexWrap: "wrap" }]}>
                                                            {getUnitPrice(medicine)}</Text>

                                                        <Text style={[TextStyle.text12, { color: AppTheme.color.grey.text, marginBottom: 4, flexWrap: "wrap" }]}>
                                                            {cap1stChar(medicine['meta'])}</Text>
                                                    </View> : null
                                                }


                                                {medicine['rxRequired'] ? <View style={[AppStyles.flexRow, {
                                                    backgroundColor: AppTheme.color.orange.activityStatus,
                                                    borderRadius: 20, padding: 4, width: 121
                                                }]}>
                                                    <IconView icon={'erx.svg'} size={9} />
                                                    <Text style={[TextStyle.text9xb, { color: 'white', marginLeft: 4 }]}>
                                                        Prescription Required</Text>
                                                </View> : null}

                                            </View>

                                            <View style={[{ alignItems: 'flex-end', alignContent: "flex-end", width: (AppTheme.appWidth - 64) * 0.3 }]}>

                                                <Text style={[TextStyle.text16xb, { marginBottom: 8, color: '#0a0a0a' }]}>{medicine['quantity']}</Text>

                                                <Text style={[TextStyle.text12, { textAlign: "right" }]}>{medicine['packing']}</Text>

                                            </View>

                                        </View>))}

                                </View> : null}

                                {orderDetails?.products && orderDetails?.products?.length != 0 && <View>
                                    {orderDetails?.products?.map((item, index) => (

                                        <View key={index} style={[AppStyles.mediumShadow, AppStyles.flexRowSpaceBetween, {
                                            borderRadius: 12, paddingHorizontal: 16, paddingVertical: 16,
                                            marginVertical: 6, width: AppTheme.appWidth - 32, backgroundColor: 'white'
                                        }]}>

                                            <View style={{ width: (AppTheme.appWidth - 64) * 0.7 }}>

                                                <Text numberOfLines={2} ellipsizeMode="head" style={TextStyle.text16b}>
                                                    {item?.productName ?? item?.name}</Text>

                                                <Text style={[TextStyle.text14b, { color: AppTheme.color.green.primary, paddingTop: 4 }]}>
                                                    {IndiaRupee} {item?.offerValue ?? getUnitPrice(item)}</Text>

                                            </View>

                                            <View style={{}}>

                                                <Text style={[TextStyle.text16xb, { textAlign: 'right' }]}>
                                                    {item['quantity']}</Text>

                                                <Text style={[TextStyle.text12, { marginTop: 8 }]}>Units</Text>

                                            </View>

                                        </View>))}

                                </View>}

                            </View> : null}

                        {imageList.length !== 0 ? <View style={AppStyles.mt24}>
                            <Text style={[TextStyle.text16b, AppStyles.mx16]}>
                                {getStringWithItemCount(imageList.length, 'Attachment', 'Attachments')}</Text>
                            <OrderImageListView imageList={imageList} marginTop={16} />

                        </View> : null}

                        {orderDetails['ropsState'] === 'paid' &&
                            orderDetails['ropsData'] ? <View style={[AppStyles.mx16, AppStyles.mt24]}>
                            <Text style={[TextStyle.text16xb, { marginTop: 24, marginBottom: 16, color: '#0A0A0A' }]}>Bill Details</Text>
                            <View style={[AppStyles.mediumShadow, { borderRadius: 12, paddingHorizontal: 16, paddingVertical: 16, marginBottom: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                                <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 4 }]}>
                                    <Text style={[TextStyle.text14]}>Total amount</Text>
                                    <Text style={[TextStyle.text14b,]}>{IndiaRupee}{orderDetails['pharmacies'][0]?.offer?.totalAmount}</Text>
                                </View>

                                {orderDetails['ropsData']?.servicePricing?.orderDeliveryChargeAmount > 0 ? <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                    <Text style={[TextStyle.text14]}>Delivery fee</Text>
                                    <Text style={[TextStyle.text14b,]}>{IndiaRupee}{orderDetails['ropsData']?.servicePricing?.orderDeliveryChargeAmount}</Text>
                                </View> : null}

                                <HorizontalDivider width={AppTheme.appWidth - 32} marginVertial={8} />

                                {orderDetails['ropsData']?.servicePricing?.pharmacyDiscountAmount > 0 ? <View>
                                    <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                        <Text style={[TextStyle.text14]}>{`Discount from chemist store (${orderDetails['ropsData']?.servicePricing?.pharmacyDiscountPct}%)`}</Text>
                                        <Text style={[TextStyle.text14b, { color: AppTheme.color.green.primary }]}>{IndiaRupee}{orderDetails['ropsData']?.servicePricing?.pharmacyDiscountAmount}</Text>
                                    </View>
                                </View> : null
                                }

                                {orderDetails['ropsData']?.servicePricing?.maxAllowedBonus > 0 ? <View>
                                    <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                        <Text style={[TextStyle.text14]}>{`Sehat Sikke discount applied (${orderDetails['ropsData']?.servicePricing?.maxAllowedBonusPctDouble}%)`}</Text>
                                        <Text style={[TextStyle.text14b, { color: 'rgba(221, 103, 0, 1)' }]}>{IndiaRupee}{orderDetails['ropsData']?.servicePricing?.maxAllowedBonus}</Text>
                                    </View>
                                </View> : null
                                }

                                {orderDetails['ropsData']?.servicePricing?.discount > 0 ? <View>
                                    <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8, color: 'rgba(16, 86, 172, 1)' }]}>
                                        <Text style={[TextStyle.text14, { color: 'rgba(16, 86, 172, 1)' }]}> {`Promo code "${orderDetails['ropsData']?.servicePricing?.ugCouponCode}" applied`}</Text>
                                        <Text style={[TextStyle.text14b, { color: 'rgba(16, 86, 172, 1)' }]}>{IndiaRupee}{orderDetails['ropsData']?.servicePricing?.discount}</Text>
                                    </View>
                                </View> : null
                                }

                                {orderDetails['ropsData']?.servicePricing?.pharmacyDiscountAmount > 0 ||
                                    orderDetails['ropsData']?.servicePricing?.maxAllowedBonus > 0 ||
                                    orderDetails['ropsData']?.servicePricing?.discount > 0 ?
                                    <HorizontalDivider width={AppTheme.appWidth - 32} marginVertial={8} /> : null}

                                <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                    <Text style={[TextStyle.text16xb,]}>Paid</Text>
                                    <Text style={[TextStyle.text16xb,]}>{IndiaRupee}{orderDetails['ropsData']?.amountPaid}</Text>
                                </View>
                            </View>
                        </View> : [2, 3, 6].includes(orderDetails['status']) ? <View
                            style={[AppStyles.px16, AppStyles.mt24]}>
                            <Text style={[TextStyle.text16xb, { marginTop: 24, marginBottom: 16, color: '#0A0A0A' }]}>Bill Details</Text>
                            <View style={[AppStyles.mediumShadow, { borderRadius: 12, paddingHorizontal: 16, paddingVertical: 16, marginBottom: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                                <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                    <Text style={[TextStyle.text14, { color: '#0A0A0A' }]}>Total amount</Text>
                                    <Text style={[TextStyle.text14b,]}>{IndiaRupee}{orderDetails['pharmacies'][0]?.offer?.totalAmount}</Text>
                                </View>

                                {orderDetails['pharmacies'][0]?.offer?.deliveryChargeAmount > 0 ? <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                    <Text style={[TextStyle.text14, { color: '#0A0A0A' }]}>Delivery fee</Text>
                                    <Text style={[TextStyle.text14b,]}>{IndiaRupee}{orderDetails['pharmacies'][0]?.offer?.deliveryChargeAmount}</Text>
                                </View> : null}

                                <HorizontalDivider width={AppTheme.appWidth - 32} marginVertial={8} />

                                {orderDetails['pharmacies'][0]?.offer?.discount > 0 ? <View>
                                    <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                        <Text style={[TextStyle.text14, { color: '#0A0A0A' }]}>{`Discount from chemist store (${orderDetails['pharmacies'][0]?.offer?.discount}%)`}</Text>
                                        <Text style={[TextStyle.text14b, { color: AppTheme.color.green.primary }]}>{IndiaRupee}{((orderDetails['pharmacies'][0]?.offer?.discount * orderDetails['pharmacies'][0]?.offer?.totalAmount) / 100).toFixed(0)}</Text>
                                    </View>
                                    <HorizontalDivider width={AppTheme.appWidth - 32} marginVertial={8} />
                                </View> : null
                                }

                                <View style={[AppStyles.flexRowSpaceBetween, { marginVertical: 8 }]}>
                                    <Text style={[TextStyle.text16xb,]}>Paid</Text>
                                    <Text style={[TextStyle.text16xb,]}>{IndiaRupee}{orderDetails['pharmacies'][0]?.offer?.payableAmount}</Text>
                                </View>
                            </View>

                        </View> : null}

                        <Text style={[TextStyle.text16xb, AppStyles.mx16, AppStyles.mt24,
                        { marginBottom: 16 }]}>Delivery Address</Text>

                        <View style={[AppStyles.mediumShadow, AppStyles.mx16, AppStyles.bgWhite, AppStyles.borderView, {
                            padding: 16, marginBottom: 16, width: AppTheme.appWidth - 32
                        }]}><View style={[AppStyles.flexRow]}>

                                {LocationIconView({
                                    locationName: orderDetails['deliveryAddress']['name'],
                                    height: 18, width: 18
                                })}
                                <Text style={[TextStyle.text14xb, { marginLeft: 4 }]}>
                                    {orderDetails['deliveryAddress']['name']}</Text>

                            </View>

                            <Text style={[TextStyle.text10,
                            { marginTop: 8 }]}>{reformatLocationString(
                                orderDetails['deliveryAddress']['flat_and_building'],
                                orderDetails['deliveryAddress']['locality'])}
                            </Text>

                        </View>

                    </View>

                </ScrollView>

            </View> : null}

            {cancleOrderModal && <MultipleOptionSelectionBottomSheet
                showModal={cancleOrderModal}
                modalTitle={'Reason for cancellation'}
                optionsList={CancelReason}
                closeModal={closeCancelOrderModal}
                primaryAction={cancelOrder} />}

            {rateOrderModal && <RateOrderModal showRatingModal={rateOrderModal}
                orderData={orderDetails}
                closeModal={closeRateOrderModal}
                primaryAction={updateRatedOrder}
            />}

        </View>
    )
}

export default OrderSummaryView
